import { createContext } from 'react';

import { BoardCategoryListType } from '@/apis/boardCategories/type';
import { BoardContentsType } from '@/apis/boardContents/types';
import { BoardInfo } from '@/apis/boards/types';
import { NoticeContentsType } from '@/apis/noticeContents/types';

interface BoardListContextType {
  bdData: BoardInfo;
  bcListData: BoardContentsType;
  bcNoticeListData: NoticeContentsType;
  bcatsData: BoardCategoryListType;
}

const BoardListContext = createContext<BoardListContextType>({
  bdData: null as any,
  bcListData: null as any,
  bcNoticeListData: null as any,
  bcatsData: null as any,
});

export default BoardListContext;
